import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Homepage from "pages/homepage";
import ProjectGallery from "pages/project-gallery";
import ContactQuoteRequest from "pages/contact-quote-request";
import ServicesCatalog from "pages/services-catalog";
import BlogResources from "pages/blog-resources";
import AboutUs from "pages/about-us";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/project-gallery" element={<ProjectGallery />} />
          <Route path="/contact-quote-request" element={<ContactQuoteRequest />} />
          <Route path="/services-catalog" element={<ServicesCatalog />} />
          <Route path="/blog-resources" element={<BlogResources />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;